module.exports = __webpack_public_path__ + "static/media/dmmca-logo@2x.09435c42.png";